import { isUsablePersonName } from '@src/util/format/userFullName';

type CoverUserNameFields = {
  id?: string;
  displayName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
};

/**
 * Builds a safe display label for cover-drawer user rows.
 * Prefer first+last, then a usable displayName, then id.
 */
export const formatCoverUserDisplayName = (user: CoverUserNameFields): string => {
  const composedName = [user.firstName, user.lastName]
    .filter((part): part is string => typeof part === 'string' && part.trim().length > 0)
    .map(part => part.trim())
    .join(' ');
  if (composedName) return composedName;

  const displayName = user.displayName?.trim();
  if (isUsablePersonName(displayName)) return displayName;

  return user.id || '—';
};
